export const getPercentage = (amount?: number, partAmount?: number) =>
  amount && partAmount ? Math.round((partAmount * 100) / amount) : 0;
